module.exports = __webpack_public_path__ + "img/ev-1.ee5bdb99.svg";